export const DEFAULT_TREATMENT_PROPS = { interventionId: 1, formularyId: 7 };

export const MOCK_INTERVENTION_LIST = [
  {
    interventionName: "Intervention 1",
    interventionId: 1,
    lastUpdatedBy: "User",
    lastUpdatedDate: "2026-03-15T12:54:40Z",
  },
  {
    interventionName: "Intervention 2",
    interventionId: 2,
    lastUpdatedBy: "User",
    lastUpdatedDate: "",
  },
];

export const MOCK_DYN_TAB_COMPLETE = [
  { key: "dressingappearance", value: "Dressing Appearance", isCompleted: 1 },
  { key: "debridement", value: "Debridement" },
];

export const TREATMENT_TAB_KEYS = [
  { key: "dressingappearance", name: "Dressing Appearance", stateKey: "dressingAppearance" },
  { key: "debridement", name: "Debridement", stateKey: "debridement" },
  { key: "woundcleanser", name: "Wound Cleanser", stateKey: "woundCleanser" },
  { key: "skinprotectant", name: "Skin Protectant", stateKey: "skinProtectant" },
  { key: "primarydressing", name: "Primary Dressing", stateKey: "primaryDressing" },
  { key: "secondarydressing", name: "Secondary Dressing", stateKey: "secondaryDressing" },
  { key: "compression", name: "Compression", stateKey: "compression" },
  { key: "modalities", name: "Modalities", stateKey: "modalities" },
  { key: "additionalcare", name: "Additional Care", stateKey: "additionalCare" },
  { key: "dressingchangefrequency", name: "Dressing Change Frequency", stateKey: "dressingChangeFrequency" },
];

export const MOCK_PRODUCT_CATEGORY_LIST = [
  {
    key: "44",
    name: "AWC Skin Protectants",
    options: [
      {
        materialNumber: "2675",
        materialCode: "MSC093001XL",
        productFamilyDesc: "Marathon Liquid Skin Protectant",
        materialDescription: "PROTECTANT,SKIN,MARATHON XL,LIQUID",
        isRecommended: 0,
      },
      {
        materialNumber: "3818",
        materialCode: "MSC093001XLH",
        productFamilyDesc: "Marathon Liquid Skin Protectant",
        materialDescription: "PROTECTANT,SKIN,MARATHON XL,LIQUID",
        isRecommended: 0,
      },
    ],
  },
];

export const MOCK_PRODUCT_CATEGORY_VIEW = [
  {
    key: "44",
    value: "2675",
  },
  {
    key: "44",
    value: "3818",
  },
];

export const MOCK_MULTISELECT_VIEW_DATA = { modalities: [{ key: "ultrasound", value: "Ultrasound" }] };
export const MOCK_MULTISELECT_LIST_OPTION_DATA = [
  { key: "negativepressurewoundtherapy", value: "Negative Pressure Wound Therapy" },
  { key: "highpressurewaterjet", value: "High Pressure Water Jet" },
  { key: "ultrasound", value: "Ultrasound" },
];

export const MOCK_DEBRIDMENT_EDIT_DATA = {
  isDebridementPerformed: "yes",
  debridementPerformedBy: "mddodpmanppamdresident",
  surgicalDebridementProcedure: "excisional(cutaway-greaterthan1.0cm²)",
  nonExcisionalApproach: "open",
  necroticSubcutaneousTissue: [],
  necroticTissue: [],
  notApplicable: [],
  depthOfDebridement: "superficial-skin",
  instrumentsUsed: ["scalpel"],
  surfaceAreaOfNecroticSkinTissue: "12",
  surfaceAreaOfNecroticSubqTissue: "12",
  postDebridementBleedingAmount: "small",
  stoppedBleedingContactPressure: "Yes",
  techniqueUsed: "",
  productCategory: [{ key: "cat1", value: "val1" }],
  data: {},
};

export const MOCK_DRESS_CHANGE = {
  data: {
    primary: {
      productCategory: [
        { productFamilyDesc: "Foam", materialDescription: "Foam Dressing", frequence: "1", frequenceType: "Days", recommended: "Yes" },
      ],
    },
    secondary: {
      productCategory: [
        { productFamilyDesc: "Gauze", materialDescription: "Gauze Dressing", frequence: "2", frequenceType: null, recommended: "No" },
      ],
    },
  },
};
